import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWelcomeContainer = styled.div`
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    padding: 100px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);

    ${media.md`
        padding: 120px 24px;
    `}

    ${media.lg`
        padding: 120px 48px;
    `}
`;

export const StyledTitleWrapper = styled(Typography)`
    font-size: 32px;
    line-height: 36px;
    padding-bottom: 20px;

    ${media.sm`
        padding-bottom: 48px;
        font-size: 48px;
        line-height: 48px;
    `}
`;

export const StyledTextWrapper = styled.div`
    & p {
        padding-bottom: 30px;
    }
`;

export const StyledFlexBox = styled(FlexBox)`
    gap: 19px;

    ${media.sm`
        gap: 40px;
    `}
`;